@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.reusable-button {
  margin-left: 10px;
}

.active-manual-store-tooltip {
  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  padding: 0 2px;
}
